import cloneDeep from 'lodash.clonedeep';

export const isObject = (val: any): boolean => {
  return (typeof val === 'object' || typeof val === 'function') && val !== null;
};

export const omit = <T extends { [n: string]: any }>(value: T, keys: string[]): T => {
  if (Array.isArray(value)) {
    for (let i = 0; i < value.length; i++) {
      value[i] = omitDeep(value[i], keys);
    }
    return value;
  }

  if (!isObject(value)) return value;
  if (typeof keys === 'string') keys = [keys];
  if (!Array.isArray(keys)) return value;

  for (let j = 0; j < keys.length; j++) {
    delete value[keys[j]];
  }

  for (const key in value) {
    if (Object.hasOwn(value, key)) {
      value[key] = omitDeep(value[key], keys);
    }
  }

  return value;
};

export const omitDeep = <T extends { [n: string]: any }>(value: T, keys: string[]): T => {
  const clone = cloneDeep(value);

  return omit<T>(clone, keys);
};
